export const LOGIN_manager_REQUEST = "LOGIN_manager_REQUEST";
export const LOGIN_manager_ERROR = "LOGIN_manager_ERROR";
export const LOGIN_manager_SUCCESS = "LOGIN_manager_SUCCESS";

export const LOGIN_DOCTOR_SUCCESS = "LOGIN_DOCTOR_SUCCESS";
export const LOGIN_DOCTOR_ERROR = "LOGIN_DOCTOR_ERROR";
export const LOGIN_DOCTOR_REQUEST = "LOGIN_DOCTOR_REQUEST";

export const LOGIN_ADMIN_ERROR = "LOGIN_ADMIN_ERROR";
export const LOGIN_ADMIN_SUCCESS = "LOGIN_ADMIN_SUCCESS";
export const LOGIN_ADMIN_REQUEST = "LOGIN_ADMIN_REQUEST";

export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const REGISTER_DOCTOR_SUCCESS = " REGISTER_DOCTOR_SUCCESS";
export const REGISTER_DOCTOR_ERROR = "REGISTER_DOCTOR_ERROR";
export const REGISTER_DOCTOR_REQUEST = "REGISTER_DOCTOR_REQUEST";

export const REGISTER_manager_SUCCESS = " REGISTER_manager_SUCCESS";
export const REGISTER_manager_ERROR = "REGISTER_manager_ERROR";
export const REGISTER_manager_REQUEST = "REGISTER_manager_REQUEST";

export const REGISTER_ADMIN_SUCCESS = " REGISTER_ADMIN_SUCCESS";
export const REGISTER_ADMIN_ERROR = "REGISTER_ADMIN_ERROR";
export const REGISTER_ADMIN_REQUEST = "REGISTER_ADMIN_REQUEST";

export const REGISTER_AMBULANCE_SUCCESS = " REGISTER_AMBULANCE_SUCCESS";
export const REGISTER_AMBULANCE_ERROR = "REGISTER_AMBULANCE_ERROR";
export const REGISTER_AMBULANCE_REQUEST = "REGISTER_AMBULANCE_REQUEST";

export const EDIT_manager_SUCCESS = " EDIT_manager_SUCCESS";
export const EDIT_manager_ERROR = "EDIT_manager_ERROR";
export const EDIT_manager_REQUEST = "EDIT_manager_REQUEST";

export const EDIT_DOCTOR_SUCCESS = " EDIT_DOCTOR_SUCCESS";
export const EDIT_DOCTOR_ERROR = "EDIT_DOCTOR_ERROR";
export const EDIT_DOCTOR_REQUEST = "EDIT_DOCTOR_REQUEST";

export const SEND_PASSWORD_SUCCESS = " SEND_PASSWORD_SUCCESS";
export const SEND_PASSWORD_ERROR = "SEND_PASSWORD_ERROR";
export const SEND_PASSWORD_REQUEST = "SEND_PASSWORD_REQUEST";

export const FORGET_PASSWORD_SUCCESS = " FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST";
